import { enUS as coreEnUS, jaJP as coreJaJP,zhCN as coreZhCN } from '@mui/material/locale';
import { enUS as gridEnUS, jaJP as gridJaJP,zhCN as gridZhCN } from '@mui/x-data-grid-premium/locales';
import { enUS as pickersEnUS, jaJP as pickersJaJP,zhCN as pickersZhCN } from '@mui/x-date-pickers/locales';

export const getMuiLocale = (language: string) => {
  switch (language) {
    case 'zh':
    case 'zh-CN':
      return [coreZhCN, gridZhCN, pickersZhCN];
    case 'ja':
    case 'ja-JP':
      return [coreJaJP, gridJaJP, pickersJaJP];
    case 'en':
    case 'en-US':
      return [coreEnUS, gridEnUS, pickersEnUS];
    default:
      return [coreEnUS, gridEnUS, pickersEnUS];
  }
};
